import { Route, Routes } from "react-router-dom";
// import socketIo from "socket.io-client"
import './App.css';
import Chat from "./component/chat/Chat";
import Join from "./component/join/join"

// const ENDPOINTS = "http://localhost:4500/"
// const socket = socketIo(ENDPOINTS,{transports:[WebSocket]})
function App() {
  // socket.on("connect",()=>{
      
  // })
  return (
    <>
   
    <Routes>
      <Route exact path="/" element={<Join />}/>
      <Route  path="/chat" element={<Chat/>}/>
    </Routes>
    </>
  );
}

export default App;
